import * as Sentry from '@sentry/react';

type CaptureErrorOptions = {
  context: Record<string, unknown>;
};

const captureError = (error: unknown, options?: CaptureErrorOptions) => {
  const publicToken = new URLSearchParams(window.location.search).get('public_token');

  const userDataContexts = {
    userData: { publicToken }
  };

  const captureContexts = {
    ...(options?.context !== undefined && { context: options.context })
  };

  Sentry.captureException(error, {
    contexts: {
      ...userDataContexts,
      ...captureContexts
    }
  });
};

export const sentry = {
  captureError
};
